/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_CancelledInputs */

const cs_tasks_protocol_cancelled = /** @type {(inputs: Tasks_Protocol_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpis zrušen`)
};

const en_tasks_protocol_cancelled = /** @type {(inputs: Tasks_Protocol_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing cancelled`)
};

/**
* | output |
* | --- |
* | "Signing cancelled" |
*
* @param {Tasks_Protocol_CancelledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_cancelled = /** @type {((inputs?: Tasks_Protocol_CancelledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_CancelledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_cancelled(inputs)
	return cs_tasks_protocol_cancelled(inputs)
});